
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/products/[page]",
      function () {
        return require("private-next-pages/sitemap/products/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/products/[page]"])
      });
    }
  